import styled from "@emotion/styled";

import { fontMerriweather, theme } from "shared/lib/styles";

export const Container = styled.div`
  margin-block-start: 40px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 60px;
  }
`;

export const Title = styled.div`
  margin-block-end: 24px;

  font-weight: 300;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 120%;
  letter-spacing: 0;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 32px;

    font-size: 32px;
  }
`;
